(function () {

    'use strict';

    angular.module('iplusjs.schaltflaeche', [
        'lodash',
        'iplusjs.utils.tracking',
        'iplusjs.utils.misc'
    ])
        .component('iplusjsSchaltflaeche', {
            require: {
                ngModel: 'ngModel'
            },
            bindings: {
                name: '@isName',
                icon: '@isIcon',
                text: '@isText',
                desc: '@isDesc',
                onChange: '&?isOnChange',
                options: '<isOptions',
                disabled: '<isDisabled'
            },
            transclude: {
                tooltip: '?tooltip'
            },
            templateUrl: 'common/schaltflaeche/schaltflaeche.html',
            controller: SchaltflaecheController,
            controllerAs: 'schaltflaecheVm'
        });

    SchaltflaecheController.$inject = [
        '$transclude',
        '$timeout',
        'lodash',
        'TrackingUtilsService',
        'MiscUtilsService'
    ];
    function SchaltflaecheController($transclude, $timeout, _, TrackingUtilsService, MiscUtilsService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.onClick = onClick;
        vm.getMainCls = getMainCls;
        vm.isButtonPressed = isButtonPressed;
        vm.getButtonLabel = getButtonLabel;
        vm.getButtonCls = getButtonCls;

        function activate() {
            vm.options = vm.options || {};

            vm.gridLayoutCss = vm.options.grid || {};
            vm.hasTooltip = $transclude.isSlotFilled('tooltip');
            vm.trackingName = _.get(vm.options, 'tracking.name') || vm.name;

            $timeout(function () {
                if (MiscUtilsService.isNotEmpty(vm.ngModel.$modelValue) && vm.ngModel.$modelValue !== false) {
                    TrackingUtilsService.trackDefaultEvent('button', 'wgv', [{
                        name: vm.trackingName,
                        value: vm.ngModel.$modelValue,
                        state: vm.disabled ? 'unchangeable' : 'default'
                    }]);
                }
            });
        }

        function onInit() {
            activate();
        }

        function onChanges() {
            activate();
        }

        function onClick($event) {
            $event && $event.preventDefault();

            if (!vm.disabled && !vm.options.inactive) {
                if (vm.ngModel.$$attr.ngValue) {
                    if (vm.ngModel.$viewValue === vm.ngModel.$$attr.ngValue) {
                        return;
                    }

                    vm.ngModel.$setViewValue(vm.ngModel.$$attr.ngValue);
                } else {
                    vm.ngModel.$setViewValue(!vm.ngModel.$modelValue);
                }

                if (angular.isFunction(vm.onChange)) {
                    vm.onChange({
                        name: vm.name,
                        value: vm.ngModel.$$attr.ngValue || vm.ngModel.$modelValue
                    });
                }

                TrackingUtilsService.trackDefaultEvent('button', 'wgv', [{
                    name: vm.trackingName,
                    value: vm.ngModel.$$attr.ngValue || vm.ngModel.$modelValue,
                    state: 'normal'
                }]);
            }
        }

        function getMainCls() {
            var cls = [(vm.icon || vm.name)];

            if (isButtonPressed()) {
                cls.push('active');
            }

            if (vm.disabled) {
                cls.push('disabled');
            } else if (vm.options.inactive) {
                cls.push('inactive');
            }

            return cls.join(' ');
        }

        function isButtonPressed() {
            if (vm.ngModel.$$attr.ngValue) {
                return vm.ngModel.$modelValue === vm.ngModel.$$attr.ngValue;
            } else {
                return !!vm.ngModel.$modelValue;
            }
        }

        function getButtonLabel() {
            return isButtonPressed() ? 'Ausgewählt' : 'Auswählen';
        }

        function getButtonCls() {
            var cls = ['button select round center secondary'];

            if (isButtonPressed()) {
                cls.push('active');
            }

            return cls.join(' ');
        }
    }

})();
